export const LINENotify = {
  methods: {
    setLINENotify: function(option = {}) {
      if (option.redirectToPage) localStorage.setItem("redirectToPage", option.redirectToPage)
      const clientId = process.env.VUE_APP_LINE_NOTIFY_ID
      const redirectURL = encodeURIComponent(process.env.VUE_APP_DOMAIN + '/LINENotifyCallback')
      const state = Math.random().toString(36).substring(2)
      const authorizeURL = `https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectURL}&scope=notify&state=${state}`;
      window.location.href = authorizeURL
      return true
    }
  }
}